import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';

import { ConfigitApiService } from './configit-api.service';
import { ConfigitQuestAdapterService } from './configit-quest-adapter.service';
import { PackerConfigitQuestAdapterService } from './packer-configit-quest-adapter.service';
import { ConflictingValueDialogComponent } from './conflicting-value-dialog.component';

@NgModule({
    imports: [CommonModule, TranslateModule, MatDialogModule, MatButtonModule],
    declarations: [ConflictingValueDialogComponent],
    providers: [ConfigitApiService, ConfigitQuestAdapterService, PackerConfigitQuestAdapterService],
})
export class ConfigitQuestAdapterModule {}
